'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasChatMessageFromAgent = undefined;

var _isFromAgent = require('../../pubnub-message/operators/isFromAgent');

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _getMessages = require('./getMessages');

var hasChatMessageFromAgent = exports.hasChatMessageFromAgent = function hasChatMessageFromAgent(threadHistory) {
  var messages = (0, _getMessages.getMessages)(threadHistory);

  return messages.some(function (message) {
    return (0, _messageTypeComparators.isChatMessage)(message) && (0, _isFromAgent.isFromAgent)(message);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasChatMessageFromAgent.js
// module id = 255
// module chunks = 2 3